






















import Vue, { PropType } from 'vue';
import WidgetWrapper from '@/components/widgets/WidgetWrapper.vue';
import { ContextualTargetData } from '@/types/campaign/targets';
import SelectChipsFromRightSlide from '@/components/chips/SelectChipsFromRightSlide.vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'TheContextualTarget',
  components: { WidgetWrapper, SelectChipsFromRightSlide },
  props: {
    data: {
      type: Object as PropType<ContextualTargetData>,
      required: true,
    },
    checked: {
      type: Number,
      default: 0,
    },
    keywords: {
      type: String,
      default: '',
    },
    errors: {
      type: Array,
      default: () => [],
    },
  },

  watch: {
    data(newValue) {
      this.campaign = newValue;
    },
    keywords() {
      this.textArea = this.keywords;
    },
  },

  computed: {
    ...mapGetters({
      category: 'categoryList',
    }),
  },

  methods: {
    input(value) {
      if (!value) {
        this.textAreaChange();
      }
      this.$emit('changeChecked', value);
    },
    textAreaChange() {
      this.$emit('changeKeywords', this.textArea);
    },
    change(name, value) {
      this.changeCampaign(name, value);
    },
    changeCampaign(name, value) {
      this.$emit('changeCampaign', name, value);
    },
    changeChecked(checked) {
      this.change('is_contextual_target', checked);
    },
    changeCategoryList(categoryList) {
      this.changeCampaign('categories', categoryList);
    },
  },

  data() {
    return {
      campaign: this.data,
      textArea: this.keywords,
    };
  },
});
